import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import FireFighting from '../../components/services/firefighting'

const FIREFIGHTING = () => {

    const faqSchema2 = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What Types Of Facilities Do You Serve?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Unique Engineers serves factories, warehouses, hospitals, commercial complexes, and institutional campuses. Each facility receives customised fire protection planning based on operational risk."
    }
  },{
    "@type": "Question",
    "name": "Do Your Systems Comply With Indian And International Standards?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "All systems comply with Indian regulations and relevant international fire safety codes. The team ensures smooth statutory approvals and inspection readiness."
    }
  },{
    "@type": "Question",
    "name": "Can You Integrate Fire Systems With Existing Building Services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, systems integrate with electrical, plumbing, and mechanical services. This integration improves response coordination and long term system reliability."
    }
  },{
    "@type": "Question",
    "name": "Do You Provide Maintenance And Audits After Installation?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, the company provides audits, testing, and maintenance support. These services help systems remain effective as building usage evolves."
    }
  },{
    "@type": "Question",
    "name": "How Do You Handle High Risk Industrial Environments?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Engineers conduct detailed risk assessments before system design. Solutions reflect material hazards, occupancy patterns, and emergency response needs."
    }
  }]

    };

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Helmet>
<title>Fire Fighting Contractors in India |  Unique Engineers</title>
<meta name="description" content="Fire fighting contractors in India delivering reliable industrial fire protection systems for factories, hospitals, warehouses, and campuses, executed by experienced industrial fire fighting contractors, Unique Engineers." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/" />

        <script type="application/ld+json">
                    {JSON.stringify(faqSchema2)}
                </script>

            </Helmet>
             <Banner img={'/assets/images/firefighting-banner.jpg'} title= 'React out and Connect' />
            <FireFighting />
        </Grid>
    )

}

export default FIREFIGHTING;